import { useState } from "react";

interface CollapsibleSectionProps {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export default function CollapsibleSection({
  title,
  count,
  defaultOpen = true,
  action,
  children,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="w-full border-b border-gray-200 last:border-b-0">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-3 text-left hover:bg-gray-50 transition-colors cursor-pointer select-none outline-none ring-0 focus:outline-none focus:ring-0 focus:bg-gray-50 focus-visible:outline-none focus-visible:ring-0"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
      >
        <div className="flex items-center gap-2">
          <span className="text-gray-400 w-4">{isOpen ? "▼" : "▶"}</span>
          <span className="font-semibold text-gray-700 uppercase text-sm tracking-wide">{title}</span>
          {count !== undefined && <span className="text-gray-400 text-sm">({count})</span>}
        </div>
        {action && <div onClick={(e) => e.stopPropagation()}>{action}</div>}
      </div>
      {isOpen && <div className="pb-4 pl-6">{children}</div>}
    </div>
  );
}
